import { render, staticRenderFns } from "./NoSuitableFound.vue?vue&type=template&id=c2a14978&scoped=true&"
import script from "./NoSuitableFound.vue?vue&type=script&lang=ts&"
export * from "./NoSuitableFound.vue?vue&type=script&lang=ts&"
import style0 from "./NoSuitableFound.vue?vue&type=style&index=0&id=c2a14978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a14978",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
